// extracted by mini-css-extract-plugin
export default {"productGrid":"_Z-z","centerLink":"a0-z","productSection":"b0-z","item":"c0-z","ctaButton":"d0-z"};